import { useState, useEffect, useContext, useRef } from 'react'
import ContextStates from '../../context/ContextStates'
import axios from 'axios';
import { Url } from '../Url';

const FViewPedido = () => {
    const [total, setTotal] = useState(0)
    const [medios, setMedios] = useState([])
    const [medioPago, setMedioPago] = useState('1')
    const [medio1, setMedio1] = useState('1')
    const [medio2, setMedio2] = useState('3')
    const [importe1, setImporte1] = useState('')
    const [importe2, setImporte2] = useState('')

    const { pedidoSelected, setViewOpen, modify, setModify, idUsuario } = useContext(ContextStates)
    const componentRef = useRef();

    useEffect(() => {
        //console.log("ver adentro ", pedidoSelected)
        const calcTotal = () => {
            let aux = 0;

            pedidoSelected.productos.forEach(element => {
                let subAux = 0;

                aux = aux + parseFloat(element.monto);
            });
            setTotal(aux)
        }
        calcTotal()
    }, [])

    useEffect(() => {
        const getMedios = async () => {
            const formData = new FormData()
            try {
                const results = await axios({
                    url: Url + 'api/listmediospago.php',
                    method: 'POST',
                    data: formData,
                })
                setMedios(results.data.results);
            } catch (e) {
                console.log(e)
            }
        }
        getMedios()
    }, [])

    const setPedidoEstado = async () => {
        const formData = new FormData()
        formData.append("idpedido", pedidoSelected.idpedido)
        formData.append("estado", pedidoSelected.estado)
        formData.append('mediopago', medioPago);
        formData.append('medio1', medio1);
        formData.append('medio2', medio2);
        formData.append('importe1', importe1);
        formData.append('total', total);
        formData.append('idusuario', idUsuario);
        try {
            const response = await axios({
                url: Url + 'api/setPedidoEstado.php',
                method: 'POST',
                data: formData,
            })
            console.log("set estado ",response)
            let aux = modify + 1
            setModify(aux)
            setViewOpen(false)
        } catch (e) {
            console.log(e)
        }
    }
    const anularPedido = async () => {
        const formData = new FormData()
        formData.append("idpedido", pedidoSelected.idpedido)

        try {
            const response = await axios({
                url: Url + 'api/anularPedido.php',
                method: 'POST',
                data: formData,
            })
            console.log(response)
            let aux = modify + 1
            setModify(aux)
            setViewOpen(false)

        } catch (e) {
            console.log(e)
        }
    }


    return (

        <div className="transition-all w-full pt-5 sm:p-3 mt-5">
            <div className="w-full mt-5 py-2 md:px-3 rounded-2xl">
                <div className='print:px-1 print:text-xs print:h-svh' ref={componentRef}>
                    <h2 className='text-center text-gray-700 text-xl mb-5'>Pedido Nº {pedidoSelected.numero}</h2>
                    <h3 className={`text-center text-gray-700 text-xl mb-5 p-4 w-full border rounded-xl ${pedidoSelected.estado === '0' ? 'bg-orange-200 border-orange-500' : 'bg-green-200 border-green-500'}`}>{pedidoSelected.descripcionestado}</h3>
                    <div className='w-full md:w-10/12 mx-auto justify-items-center'>
                        <p className='text-center mt-4 text-xl'>{pedidoSelected.descripcion}</p>
                        {parseInt(pedidoSelected.estado) === 0 && (
                            <div className='w-full p-3'>
                                <div className='w-full sm:flex'>
                                    <div className='bg-gray-50 rounded-lg p-5 w-full'>
                                        {typeof medios !== 'undefined' && medios.map((item, index) =>
                                            <div key={index} className="radio">
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="medioPago"
                                                        value={item.id}
                                                        checked={medioPago === item.id}
                                                        onChange={() => setMedioPago(item.id)}
                                                        className='mr-5'
                                                    />
                                                    {item.descripcion}
                                                </label>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {medioPago === '7' && (
                                    <>
                                        <div className='w-full mt-5 bg-blue-50 rounded-lg p-5'>
                                            <p className='text-xl font-bold'>Medio de Pago 1</p>
                                            <div className='rounded-lg p-5 w-full'>
                                                {typeof medios !== 'undefined' && medios.map((item, index) =>
                                                    item.id !== '7' &&
                                                    <div key={index} className="radio">
                                                        <label>
                                                            <input
                                                                type="radio"
                                                                name="medioPago1"
                                                                value={item.id}
                                                                checked={medio1 === item.id}
                                                                onChange={() => setMedio1(item.id)}
                                                                className='mr-5'
                                                            />
                                                            {item.descripcion} {item.id === '3' && '(20% de recargo con éste medio)'}
                                                        </label>
                                                    </div>
                                                )}
                                                <label className="block text-gray-800" htmlFor='importe1'>Importe Medio de Pago 1</label>
                                                <input
                                                    type='text'
                                                    className={`p-2 rounded border border-gray-400 w-full ${importe1 > total ? 'bg-red-300' : 'bg-white'}`}
                                                    value={importe1}
                                                    id="importe1"
                                                    onChange={(e) => setImporte1(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className='w-full mt-5 mb-10 bg-blue-50 rounded-lg p-5'>
                                            <p className='text-xl font-bold'>Medio de Pago 2</p>
                                            <div className='mt-2 rounded-lg p-5 w-full'>
                                                {typeof medios !== 'undefined' && medios.map((item, index) =>
                                                    item.id !== '7' && item.id !== medio1 &&
                                                    <div key={index} className="radio">
                                                        <label>
                                                            <input
                                                                type="radio"
                                                                name="medioPago2"
                                                                value={item.id}
                                                                checked={medio2 === item.id}
                                                                onChange={() => setMedio2(item.id)}
                                                                className='mr-5'
                                                            />
                                                            {item.descripcion} {item.id === '3' && '(20% de recargo con éste medio)'}
                                                        </label>
                                                    </div>
                                                )}
                                                <label className="block text-gray-800" htmlFor='importe2'>Importe Medio de Pago 2</label>
                                                <input
                                                    type='text'
                                                    className='p-2 rounded border border-gray-400 w-full'
                                                    value={importe2}
                                                    id="importe2"
                                                    onChange={(e) => setImporte2(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        )}

                        {typeof pedidoSelected.productos !== 'undefined' && pedidoSelected.productos.map((item, index) => (
                            <div key={index} className='w-full border border-gray-200 rounded mb-1'>
                                <div className='w-full font-semibold flex mt-2 p-1 md:p-2'>
                                    <div className='w-1/6 print:w-0 print:invisible'>
                                        <img className='md:w-1/3 object-cover rounded' src={Url + item.imagen} />
                                    </div>
                                    <div className='w-3/6 print:w-4/5 print:pr-10'>
                                        <p className='text-left print:text-xs ml-2 print:ml-0'>{`${parseInt(item.cantidad)} x ${item.descripcion}`}</p>
                                    </div>
                                    <div className='w-2/6 print:pr-10'>
                                        <p className='text-right print:text-xs'>$ {parseFloat(item.monto).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                                    </div>
                                </div>
                                {typeof item.subproductos !== 'undefined' && item.subproductos.map((item, index) => (
                                    <div key={index}>
                                        <div className='pl-10 mt-0'>
                                            <div className='print:pl-2 print:pr-10'>
                                                <p className='text-left ml-10 print:text-xs'>{item.descripcion}<span className='font-bold'>{item.precio !== '0' && (' - $ ' + item.precio)}</span></p>

                                            </div>
                                        </div>
                                    </div>
                                ))}
                                {item.nota && item.nota !== '' && (
                                    <div className='w-full mt-2 p-2'>
                                        <p><span className='font-semibold'>Nota: </span>{item.nota}</p>
                                    </div>
                                )}
                            </div>
                        ))}
                        <div className='w-full font-semibold flex mt-2 p-2'>
                            <div className='w-full pl-2'>
                                <p className='text-left font-bold uppercase text-3xl print:text-sm'>Total</p>
                            </div>
                            <div className='w-full pr-10'>
                                <p className='text-right font-bold uppercase text-3xl print:text-sm'>${parseFloat(total).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-full rounded-lg mt-10">
                    <div className='w-full md:flex'>
                        {parseInt(pedidoSelected.estado) < 2 && (
                            <div className='w-full md:w-1/2 flex'>
                                <button
                                    type="button"
                                    className={`w-full mr-4 shadow-md p-3 text-white transition-all uppercase font-bold rounded-lg mt-5 ${pedidoSelected.estado === '0' ? 'bg-orange-500' : pedidoSelected.estado === '1' && 'bg-blue-500'}`}
                                    onClick={() => setPedidoEstado()}
                                >
                                    {pedidoSelected.estado === '0' ? 'Marcar como Pagado' : pedidoSelected.estado === '1' && 'Marcar como Entregado'}
                                </button>
                                {pedidoSelected.estado === '0' && (
                                    <button
                                        type="button"
                                        className={`w-full mr-4 shadow-md p-3 text-white transition-all uppercase font-bold rounded-lg mt-5 bg-red-600`}
                                        onClick={() => anularPedido()}
                                    >
                                        Anular Pedido
                                    </button>
                                )}
                            </div>
                        )}
                        <div className='w-full md:w-1/2'>
                            <button
                                type="button"
                                className={`w-full md:ml-4 shadow-md p-3 text-white transition-all uppercase font-bold rounded-lg mt-5 bg-gray-500`}
                                onClick={() => setViewOpen(false)}
                            >
                                Salir
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FViewPedido